(function () {
  'use strict';

  const CART_PROGRESS_SELECTOR = '[data-cart-progress]';

  let isFetchingCart = false;
  let hasCelebratedGift = false;
  let hasCelebratedShipping = false;
  let pendingToastCheck = false;


  function formatMoney(cents) {
    const currency =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'AED';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return currency + ' ' + (cents / 100).toFixed(2);
    }
  }

  /**
   * Same date-based threshold logic as the Liquid snippet, mirrored in JS
   * so the popup works even on pages where the bar itself isn't rendered.
   * Note: this only covers the free-shipping threshold (used by the toast).
   * The free-gift threshold (AED 150) has no promo override.
   */
  function getCurrentFreeShippingThreshold() {
    const now = new Date();
    const todayStr = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0');

    const promoStart = '2026-09-09';
    const promoEndExclusive = '2026-09-11';

    if (todayStr >= promoStart && todayStr < promoEndExclusive) {
      return 9900; // AED 99
    }
    return 20000; // AED 200
  }


  let toastEl = null;
  let toastHideTimer = null;

  function showFreeShippingToast(remainingCents) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'free-shipping-toast';
      document.body.appendChild(toastEl);
    }

    toastEl.innerHTML =
      "Add <strong>" + formatMoney(remainingCents) + "</strong> more to get free shipping!";

    requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });

    clearTimeout(toastHideTimer);
    toastHideTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 4000);
  }

  function celebrate(bar, markerKey) {
    const marker = bar.querySelector('[data-cart-progress-marker="' + markerKey + '"]');
    if (!marker) return;

    const colors = ['#e348af', '#f36bc1', '#ffd166', '#06d6a0', '#118ab2'];

    for (let i = 0; i < 18; i++) {
      const piece = document.createElement('span');
      piece.className = 'cart-progress__confetti-piece';
      const angle = Math.random() * Math.PI * 2;
      const distance = 40 + Math.random() * 50;
      piece.style.setProperty('--x', Math.cos(angle) * distance + 'px');
      piece.style.setProperty('--y', Math.sin(angle) * distance - 30 + 'px');
      piece.style.setProperty('--r', Math.random() * 360 + 'deg');
      piece.style.background = colors[i % colors.length];
      piece.style.left = 'calc(100% - 40px)';
      marker.appendChild(piece);
      setTimeout(() => piece.remove(), 950);
    }
  }


  /*
   * PAUSED — collection-quantity helpers for the quantity-based tiers.
   * Uncomment when re-enabling those tiers.
   *
   * function getQtyInCollection(cart, collectionProductIds) {
   *   if (!collectionProductIds || collectionProductIds.size === 0) return 0;
   *   let qty = 0;
   *   (cart.items || []).forEach(function (item) {
   *     if (collectionProductIds.has(item.product_id)) {
   *       qty += item.quantity;
   *     }
   *   });
   *   return qty;
   * }
   *
   * function parseCollectionIds(bar) {
   *   const raw = bar.dataset.collectionProductIds || '';
   *   const ids = raw
   *     .split(',')
   *     .map(function (id) { return parseInt(id.trim(), 10); })
   *     .filter(function (id) { return Number.isFinite(id); });
   *   return new Set(ids);
   * }
   */


  function updateProgressBar(bar, cart) {
    if (!bar || !cart) return;

    const giftMoney = Number(bar.dataset.giftMoney);
    const shippingMoney = Number(bar.dataset.shippingMoney);

    if (
      !Number.isFinite(giftMoney) || giftMoney <= 0 ||
      !Number.isFinite(shippingMoney) || shippingMoney <= 0
    ) {
      console.warn('Cart Progress: Invalid threshold values.', bar);
      return;
    }

    const itemCount = cart.item_count || 0;

    if (itemCount === 0) {
      bar.hidden = true;
      hasCelebratedGift = false;
      hasCelebratedShipping = false;
      return;
    }

    bar.hidden = false;

    const subtotal =
      typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : cart.total_price || 0;

    const giftUnlocked = subtotal >= giftMoney;
    const shippingUnlocked = subtotal >= shippingMoney;

    // Keep the fill/markers correct even in the edge case where a promo
    // pushes the shipping threshold below the gift threshold.
    const maxThreshold = Math.max(giftMoney, shippingMoney);

    const percentage = Math.max(0, Math.min((subtotal / maxThreshold) * 100, 100));

    const fill = bar.querySelector('[data-cart-progress-fill]');
    if (fill) {
      fill.style.width = percentage + '%';
    }

    const track = bar.querySelector('[data-cart-progress-track]');
    if (track) {
      track.setAttribute('aria-valuenow', String(subtotal));
    }

    const giftMarker = bar.querySelector('[data-cart-progress-marker="gift"]');
    if (giftMarker) giftMarker.classList.toggle('is-active', giftUnlocked);

    const shippingMarker = bar.querySelector('[data-cart-progress-marker="shipping"]');
    if (shippingMarker) shippingMarker.classList.toggle('is-active', shippingUnlocked);

    const giftJustUnlocked = giftUnlocked && !hasCelebratedGift;
    if (giftJustUnlocked) {
      hasCelebratedGift = true;
      celebrate(bar, 'gift');
    } else if (!giftUnlocked) {
      hasCelebratedGift = false;
    }

    const shippingJustUnlocked = shippingUnlocked && !hasCelebratedShipping;
    if (shippingJustUnlocked) {
      hasCelebratedShipping = true;
      celebrate(bar, 'shipping');
    } else if (!shippingUnlocked) {
      hasCelebratedShipping = false;
    }

    const message = bar.querySelector('[data-cart-progress-message]');
    if (!message) return;

    if (!giftUnlocked) {
      const remaining = giftMoney - subtotal;
      message.innerHTML =
        "You're <strong>" + formatMoney(remaining) + "</strong> away from a free gift!";
    } else if (!shippingUnlocked) {
      const remaining = shippingMoney - subtotal;
      message.innerHTML =
        "Free gift unlocked! Add <strong>" + formatMoney(remaining) + "</strong> more for free shipping.";
    } else {
      message.innerHTML = "You've unlocked <strong>free gift &amp; free shipping</strong> 🎉";
    }

    /*
     * PAUSED — quantity-based tier logic. Restore this whole block when
     * re-enabling those tiers. Also uncomment getQtyInCollection /
     * parseCollectionIds above, and read tier3Qty / tier4Money from the
     * bar's dataset.
     *
     * const tier3Qty = Number(bar.dataset.tier3Qty);
     * const tier4Money = Number(bar.dataset.tier4Money);
     *
     * const collectionProductIds = parseCollectionIds(bar);
     * const qtyInCollection = getQtyInCollection(cart, collectionProductIds);
     *
     * const tier3Unlocked = qtyInCollection >= tier3Qty;
     * const tier4Unlocked = subtotal >= tier4Money;
     *
     * const marker3 = bar.querySelector('[data-cart-progress-marker="3"]');
     * if (marker3) marker3.classList.toggle('is-active', tier3Unlocked);
     *
     * const marker4 = bar.querySelector('[data-cart-progress-marker="4"]');
     * if (marker4) marker4.classList.toggle('is-active', tier4Unlocked);
     *
     * if (!giftUnlocked) {
     *   message.innerHTML = "You're <strong>" + formatMoney(giftMoney - subtotal) + "</strong> away from a free gift!";
     * } else if (!shippingUnlocked) {
     *   message.innerHTML = "Free gift unlocked! Add <strong>" + formatMoney(shippingMoney - subtotal) + "</strong> more for free shipping.";
     * } else if (!tier3Unlocked) {
     *   message.innerHTML = "Free shipping unlocked! Add <strong>" + (tier3Qty - qtyInCollection) + "</strong> more from Back to Routine for 20% off + a free gift.";
     * } else if (!tier4Unlocked) {
     *   message.innerHTML = "20% off + gift unlocked! Add <strong>" + formatMoney(tier4Money - subtotal) + "</strong> more to unlock a free Purito Seoul Best Kit.";
     * } else {
     *   message.innerHTML = "You've unlocked <strong>every reward</strong> 🎉";
     * }
     */
  }


  function renderProgressBars(cart, allowToast) {
    const progressBars = document.querySelectorAll(CART_PROGRESS_SELECTOR);
    progressBars.forEach(function (bar) {
      updateProgressBar(bar, cart);
    });

    if (allowToast && pendingToastCheck) {
      pendingToastCheck = false;
      const threshold = getCurrentFreeShippingThreshold();
      const subtotal =
        typeof cart.items_subtotal_price === 'number'
          ? cart.items_subtotal_price
          : cart.total_price || 0;

      if (subtotal < threshold) {
        showFreeShippingToast(threshold - subtotal);
      }
    }
  }


  async function fetchCart(allowToast) {
    if (isFetchingCart) return;
    isFetchingCart = true;

    try {
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(root + 'cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Cart request failed: ' + response.status);
      }

      const cart = await response.json();
      renderProgressBars(cart, allowToast === true);
    } catch (error) {
      console.error('Cart Progress:', error);
    } finally {
      isFetchingCart = false;
    }
  }


  function scheduleCartUpdate() {
    setTimeout(function () { fetchCart(false); }, 150);
    setTimeout(function () { fetchCart(true); }, 600);
  }


  function initializeCartProgress() {
    fetchCart();
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCartProgress);
  } else {
    initializeCartProgress();
  }


  try {
    if (
      typeof window.subscribe === 'function' &&
      window.PUB_SUB_EVENTS &&
      window.PUB_SUB_EVENTS.cartUpdate
    ) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        scheduleCartUpdate();
      });
    } else if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        scheduleCartUpdate();
      });
    }
  } catch (error) {
    /* fallbacks below cover this */
  }


  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!target) return;
    if (target.matches('.quantity__input') || target.matches('input[name="updates[]"]')) {
      scheduleCartUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!target) return;
    const quantityButton = target.closest('.quantity__button');
    const removeButton = target.closest('cart-remove-button');
    const removeLink = target.closest('[id^="Remove-"]');
    if (quantityButton || removeButton || removeLink) {
      scheduleCartUpdate();
    }
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form) return;
    const action = form.getAttribute('action') || '';
    if (action.includes('/cart/add')) {
      pendingToastCheck = true;
      scheduleCartUpdate();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    scheduleCartUpdate();
  });

  window.addEventListener('pageshow', function () {
    scheduleCartUpdate();
  });

  let mutationTimer = null;

  const observer = new MutationObserver(function (mutations) {
    let cartChanged = false;

    mutations.forEach(function (mutation) {
      if (!mutation.addedNodes.length) return;

      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches &&
          (node.matches('cart-drawer') ||
            node.matches('cart-items') ||
            node.matches('[data-cart-progress]'))
        ) {
          cartChanged = true;
        }

        if (
          node.querySelector &&
          (node.querySelector('[data-cart-progress]') || node.querySelector('cart-drawer'))
        ) {
          cartChanged = true;
        }
      });
    });

    if (!cartChanged) return;

    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(function () { fetchCart(); }, 150);
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  setInterval(function () {
    if (document.querySelector(CART_PROGRESS_SELECTOR)) {
      fetchCart();
    }
  }, 2000);
})();